/**
 * newTodoEvent — une activité poussée par le tuteur (`newTodo`), telle que la machine de l'élève la
 * lit : à qui elle va, l'activité, et si elle prend la place de la courante (`forceFocus`).
 *
 * L'activité voyage sans les marques de son énoncé, l'énoncé marqué à côté (`liveTodoPayload`) : elle
 * est relue avec lui, sans quoi une activité neuve s'affichait sans ses repères (la consigne, la
 * donnée, la notion, le piège) jusqu'au relevé du serveur. Comme l'écouteur d'avant
 * (`useLiveKitEventListener`).
 */
import { fromLiveTodoPayload } from "../room/liveTodoPayload"

export type NewTodo = {
    /** L'élève visé. */
    studentId: unknown
    activity: Record<string, unknown> | null
    forceFocus: boolean
}

type ActivityList = { id?: number | string | null }[] | null | undefined

/**
 * L'élève avait déjà l'activité, à faire ou faite : sans `forceFocus`, c'est un titre modifié ou une liste
 * réordonnée, pas une activité ajoutée. Lu sur le compte d'AVANT la relecture que l'événement déclenche.
 */
export function accountHasActivity(
    account: { todo_activities?: ActivityList; activities?: ActivityList } | null | undefined,
    activityId: number
): boolean {
    return [account?.todo_activities, account?.activities].some((list) =>
        (list ?? []).some((activity) => activity?.id != null && Number(activity.id) === activityId)
    )
}

export function readNewTodo(event: Record<string, unknown>): NewTodo {
    // Le corps est sous `data` (l'émetteur d'avant) ou à plat (celui du moteur).
    const data = ((event.data as Record<string, unknown> | undefined) ?? event) as Record<string, unknown>
    return {
        studentId: data.id,
        activity: (fromLiveTodoPayload(data) as Record<string, unknown> | null | undefined) ?? null,
        forceFocus: data.forceFocus === true,
    }
}
